import { RouteModule } from '#/horizon/components/RouteModule';
import type { LoaderDataWithOverrideLocale } from '#/horizon/useMatchesOverrideLocale';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardViewJobRecommendedCandidateRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { OrgDashboardOrgSubLayoutHandleProps } from '#/modules/orgDashboard/sub-layouts/Org/OrgDashboardOrgSubLayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardViewJobRecommendedCandidatePageLoadable } from './OrgDashboardViewJobRecommendedCandidatePageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: false,
  darkBackground: true,
  showDesktopSearch: true,
  orgDashboardSubLayoutVariant: 'base',
} satisfies LayoutHandleProps & OrgDashboardOrgSubLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<
    typeof orgDashboardViewJobRecommendedCandidateRoute
  >,
) {
  await OrgDashboardViewJobRecommendedCandidatePageLoadable.load();

  return {
    overrideLocale: I18nLocale.EN,
  } satisfies LoaderDataWithOverrideLocale;
}

export default function OrgDashboardViewJobRecommendedCandidateHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Candidate Details')}>
      <OrgDashboardViewJobRecommendedCandidatePageLoadable />
    </RouteModule>
  );
}
